import { Controller } from '@hotwired/stimulus'

// Part 11 signature challenge (ux-design §6.4). The two-component challenge,
// password re-verification and the "meaning" timestamps are all handled
// server-side; this controller only owns the failure microinteraction:
// when the server re-renders the challenge after a wrong password, the
// password input shakes, clears and refocuses — no re-sign loop, the rest
// of the draft is preserved.
export default class extends Controller {
  static targets = ['password']
  static values = { invalid: Boolean }

  connect () {
    if (this.invalidValue) this.shake()
  }

  shake () {
    if (!this.hasPasswordTarget) return

    this.passwordTarget.value = ''
    this.passwordTarget.classList.add('animate-shake')
    this.passwordTarget.addEventListener(
      'animationend',
      () => this.passwordTarget.classList.remove('animate-shake'),
      { once: true }
    )
    this.passwordTarget.focus()
  }
}
